/**
 * SIM-1502 — toast helpers shared across all four T2 sections. Warnings from the backend's
 * non-blocking T2↔T3 sanity check surface as one toast per string; mutation failures route through
 * `formatZodError`, because a raw Zod message must never reach the user.
 */
import { formatZodError } from "@Simplicity-Education/core";
import { sonnerToast } from "@simplicity/ui";

export function notifyWarnings(warnings: string[]): void {
  for (const w of warnings) {
    sonnerToast.warning(w);
  }
}

export function notifyMutationError(action: string, err: unknown): void {
  const description = formatZodError(err, { unknownFallback: `${action} failed.` });
  sonnerToast.error(`${action} failed`, { description });
}
